import React from 'react';
import { Comment } from '../types';

type Props = {
  comments: Comment[];
  newComment: string;
  onChangeNewComment: (v: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  currentUserId?: string;
  onEdit: (c: Comment) => void;
  onDelete: (id: string) => void;
};

export default function CommentsSection({
  comments,
  newComment,
  onChangeNewComment,
  onSubmit,
  currentUserId,
  onEdit,
  onDelete
}: Props) {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Comentários</h3>
      <form onSubmit={onSubmit} className="mb-8 flex space-x-4">
        <textarea
          value={newComment}
          onChange={(e) => onChangeNewComment(e.target.value)}
          placeholder="Adicione um comentário..."
          rows={2}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <button type="submit" className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700">Comentar</button>
      </form>
      <div className="space-y-6">
        {comments.map((comment) => (
          <div key={comment.id} className="flex space-x-4">
            <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center text-white font-bold">
              {comment.profiles?.full_name?.charAt(0) || 'U'}
            </div>
            <div className="flex-1 bg-gray-50 rounded-lg p-4">
              <div className="flex justify-between items-center mb-2">
                <h4 className="font-medium text-gray-900">{comment.profiles?.full_name || 'Usuário'}</h4>
                <span className="text-sm text-gray-500">{new Date(comment.created_at).toLocaleString('pt-BR')}</span>
              </div>
              <p className="text-gray-700">{comment.content}</p>
              {comment.user_id === currentUserId && (
                <div className="mt-3 flex gap-3">
                  <button onClick={() => onEdit(comment)} className="text-gray-500 hover:text-gray-700 flex items-center gap-1 cursor-pointer">
                    <i className="ri-edit-line"></i>
                    Editar
                  </button>
                  <button onClick={() => onDelete(comment.id)} className="text-red-600 hover:text-red-700 flex items-center gap-1 cursor-pointer">
                    <i className="ri-delete-bin-line"></i>
                    Excluir
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}